import View from './view.js'
import React from 'react'
import usePreviousQuestion from 'Logic/use-previous-question.js'

export default function Logic(props) {
  let previousQuestion = usePreviousQuestion()
  return <View {...props} {...previousQuestion} />
}
